import React, { useState } from "react";
import GetInTouch from "../components/GetinTouch/GetInTouch";
import "./DsaPage.css";
import Dsaprofile from "./Dsaprofile";
import Loader from "./Loader";
function DsaPage() {
  const [flag, setflag] = useState(true);

  setTimeout(() => {
    setflag(false);
  }, 3000);

  return (
    <div className="dsa-profile-page-section">
      {flag && <Loader></Loader>}
      {!flag && (
        <div>
          <Dsaprofile></Dsaprofile>
          <GetInTouch></GetInTouch>
        </div>
      )}
    </div>
  );
}

export default DsaPage;
